/** Tire un id de pilote au hasard, en évitant la répétition immédiate si possible. */
export function pickNextFeaturedPilotId(
  ids: readonly number[],
  lastId: number | null,
  random: () => number = Math.random
): number | null {
  if (ids.length === 0) return null;
  if (ids.length === 1) return ids[0] ?? null;

  const pool = lastId == null ? [...ids] : ids.filter((id) => id !== lastId);
  const choices = pool.length > 0 ? pool : [...ids];
  const index = Math.min(choices.length - 1, Math.floor(random() * choices.length));
  return choices[index] ?? null;
}
